function placeholderSrc() {
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''
    const baseUrl = apiBaseUrl.replace(/\/api\/?$/, '')
    return `${baseUrl}/images/default-avatar-1.png`
}

function setSource(el, value) {
    if (el instanceof SVGElement) {
        el.setAttribute('href', value)
        el.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', value)
    } else {
        el.src = value
    }
}

function applyValue(el, value) {
    el.__avatarFallbackFailed = false
    setSource(el, value || placeholderSrc())
}

export const avatarFallback = {
    mounted(el, binding) {
        el.__onAvatarError = () => {
            if (el.__avatarFallbackFailed) {
                return
            }
            el.__avatarFallbackFailed = true
            setSource(el, placeholderSrc())
        }
        el.addEventListener('error', el.__onAvatarError)
        applyValue(el, binding.value)
    },
    updated(el, binding) {
        if (binding.value !== binding.oldValue) {
            applyValue(el, binding.value)
        }
    },
    unmounted(el) {
        el.removeEventListener('error', el.__onAvatarError)
    },
}

export default avatarFallback
